function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// eslint-disable-next-line no-shadow
export var ImageType = /*#__PURE__*/function (ImageType) {
  ImageType["WEBP"] = "webp";
  ImageType["AVIF"] = "avif";
  return ImageType;
}({});
var getSrcSetPicture = function getSrcSetPicture(image, imageType) {
  if (imageType === ImageType.WEBP && _typeof(image) === "object" && image.srcWebp) {
    return "".concat(image.srcWebp, " 1x ").concat(image.retinaSrcWebp ? ", ".concat(image.retinaSrcWebp, " 2x") : "");
  }
  if (imageType === ImageType.AVIF && _typeof(image) === "object" && image.srcAvif) {
    return "".concat(image.srcAvif, " 1x ").concat(image.retinaSrcAvif ? ", ".concat(image.retinaSrcAvif, " 2x") : "");
  }
  if (_typeof(image) === "object") {
    return "".concat(image.src, " 1x ").concat(image.retinaSrc ? ", ".concat(image.retinaSrc, " 2x") : "");
  }
  return image;
};
export default getSrcSetPicture;